const CURRENCIES = {
  default: 'EUR',
  defaultFX: 'USD',
  filters: ['USD', 'EUR', 'GBP'],
};

export default CURRENCIES;
